import { routerStyxie } from '@/router/styxieBridge'
import { useMlapSettingsStore } from '@/stores/mlapSettings'

// Client-side routed: the payload hydrates the settings store for the first
// render, later entries fetch the /mlap/ajax twin (see router/routes/mlap.js).
Styxie.Initializers.MlapSettingsGoogleAds = routerStyxie({
  actions: ['show'],
  hydrate: (props, pinia) => useMlapSettingsStore(pinia).hydrate('googleAds', props)
})
